import React from "react";

function MerchantReviews(props) {
  return <div>Merchant Reviews</div>;
}

export default MerchantReviews;
